import React, { useContext, useMemo } from "react";
import { format } from "date-fns";

import { Context } from "../../../store/student";
import styles from "../CareerAnswerHistory.module.scss";

const TABLE_TITLES = [
  "興味のあるトピック",
  "将来のイメージ",
  "進路イメージ",
  "希望の進路",
];

const CareerChallengeSheetTable = () => {
  const { contextState } = useContext(Context);
  const careerChallengeSheets = contextState.career_challenge_sheets;
  const sortedChallengeSheetsByTermNo = useMemo(() => {
    return [...careerChallengeSheets].sort((a, b) => b.term_no - a.term_no);
  }, [careerChallengeSheets]);

  console.log(
    "sortedChallengeSheetsByTermNo---",
    sortedChallengeSheetsByTermNo,
  );

  return (
    <>
      {careerChallengeSheets.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>問い</th>
              {TABLE_TITLES.map((title, index) => (
                <th key={index}>{title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedChallengeSheetsByTermNo.map(sheet => (
              <tr key={sheet.id}>
                <td>
                  <div>{sheet.term_no}回目</div>
                  <div className={styles.date}>
                    {sheet.submitted_at
                      ? format(new Date(sheet.submitted_at), "yyyy.M.d")
                      : ""}
                  </div>
                </td>
                <td>
                  {sheet.topics.map((topic, index) => (
                    <span key={index} className={styles.answer}>
                      {topic.content}
                    </span>
                  ))}
                </td>
                <td>
                  {sheet.futures.map((future, index) => (
                    <div key={index} className={styles.row}>
                      <span className={styles.answer}>{future.when_where}</span>
                      <span className={styles.answer}>{future.what}</span>
                      <span className={styles.answer}>{future.reason}</span>
                      <span className={styles.answer}>
                        希望度：{future.score}
                      </span>
                    </div>
                  ))}
                </td>
                <td>
                  {sheet.careers.map((career, index) => (
                    <div key={index} className={styles.row}>
                      <span className={styles.answer}>{career.content}</span>
                      <span className={styles.answer}>{career.reason}</span>
                      <span className={styles.answer}>
                        希望度：{career.score}
                      </span>
                    </div>
                  ))}
                </td>
                <td>
                  {sheet.hopes.map((hope, index) => (
                    <div key={index} className={styles.row}>
                      <span className={styles.answer}>{hope.destination}</span>
                      <span className={styles.answer}>{hope.faculty}</span>
                      <span className={styles.answer}>{hope.reason}</span>
                      <span className={styles.answer}>
                        希望度：{hope.score}
                      </span>
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className={styles.message}>回答データがありません。</p>
      )}
    </>
  );
};

export default CareerChallengeSheetTable;
